import type { HeySynclyChat } from '@/entities/hey-syncly';
import type { AnalysisGptSocketPayload } from '@/features/Analysis/types';
import type {
  GptSocketBasePayload,
  GptSocketSearchSummaryPayload,
} from '@/types/gptConst';

import { defaultAxios } from '..';

const gptService = {
  async requestSearchAsk(
    alias: string,
    socketBase: GptSocketBasePayload,
    payload?: StructuredFilter,
  ): Promise<HeySynclyChat> {
    const res = await defaultAxios.post(`/searches/${alias}/ask`, {
      ...socketBase,
      filter: payload,
    });
    return res.data;
  },
  async requestSearchSummaryAsk(
    socketBase: GptSocketBasePayload,
    payload: GptSocketSearchSummaryPayload,
  ): Promise<HeySynclyChat> {
    if (typeof payload.sub_issue_index === 'number') {
      const res = await defaultAxios.post(
        `/searches/${payload.alias}/issues/${payload.issue_index}/subissues/${payload.sub_issue_index}/ask`,
        {
          ...socketBase,
        },
      );
      return res.data;
    }
    const res = await defaultAxios.post(
      `/searches/${payload.alias}/issues/${payload.issue_index}/ask`,
      {
        ...socketBase,
      },
    );
    return res.data;
  },
  async requestAnalysisAsk(
    dashboard_alias: string,
    payload: AnalysisGptSocketPayload,
  ): Promise<HeySynclyChat> {
    const res = await defaultAxios.post(
      `/dashboards3/${dashboard_alias}/analysis/ask`,
      payload,
    );
    return res.data;
  },
};

export default gptService;
